import { profileEditionByType } from "views/Config/Rules/ProfMenuItem";

export const VIEW = "viewRulesFlow";

export const POLI = {
  attr: "poli",
  type: "policy",
  cmdRespColIdx: 13,
  titleEdit: "Policy",
  header: "POLICY",
};

export const PROFS = [
  {
    attr: "if",
    cmdRespColIdx: 2,
    type: "interface",
    titleEdit: "Interface Profile",
    header: "INTERFACE",
  },
  {
    attr: "vlan",
    cmdRespColIdx: 3,
    type: "vlan",
    titleEdit: "VLAN Profile",
    header: "VLAN",
  },
  {
    attr: "policiesRate",
    cmdRespColIdx: 4,
    type: "policy-rate",
    titleEdit: "Policy-Rate Profile",
    header: "POLICY-RATE",
  },
  {
    attr: "int",
    cmdRespColIdx: 5,
    type: "internet",
    titleEdit: "Internet Profile",
    header: "INTERNET",
  },
  {
    attr: "subscriberGroup",
    cmdRespColIdx: 6,
    type: "subscriber-group",
    titleEdit: "Subscriber Group Profile",
    header: "SUB-GROUP",
  },
  {
    attr: "subscriberId",
    cmdRespColIdx: 7,
    type: "subscriber-id",
    titleEdit: "Subscriber ID Profile",
    header: "SUB-ID",
  },
  {
    attr: "acc",
    cmdRespColIdx: 8,
    type: "access",
    titleEdit: "Access Profile",
    header: "ACCESS",
  },
  {
    attr: "time",
    cmdRespColIdx: 9,
    type: "time",
    titleEdit: "Time Profile",
    header: "TIME",
  },
  {
    attr: "throu",
    cmdRespColIdx: 10,
    type: "throughput",
    titleEdit: "Throughput Profile",
    header: "THROUGHPUT",
  },
  {
    attr: "dscp",
    cmdRespColIdx: 11,
    type: "dscp",
    titleEdit: "DSCP Profile",
    header: "DSCP",
  },
  {
    attr: "dpi",
    cmdRespColIdx: 12,
    type: "dpi",
    titleEdit: "DPI Profile",
    header: "DPI",
  },
];

export const TYPE_PROFILE_SHORTCUTF_MAP = {
  ...profileEditionByType(PROFS),
  policy: function (poliName, viewName, tab) {
    globalNavigate("viewPolicyFlowEdit", {returnView: viewName, policy: poliName, tab});
  },
};
